import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "hamburguer__line a" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "hamburguer__line b" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "hamburguer__line c" }, null, -1)
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]

import { ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavAltButton',
  props: ["close"],
  emits: ["open", "close"],
  setup(__props, { emit: __emit }) {

const props = __props;

watch(
  () => props.close,
  () => {
    isOpen.value = false;
  }
);

let isOpen = ref(false);
const emit = __emit;

function emitEvents() {
  if (isOpen.value == false) {
    emit("open");
    isOpen.value = true;
  } else {
    emit("close");
    isOpen.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: emitEvents,
    class: _normalizeClass(["hamburguer__button", { active: _unref(isOpen), noTransition: props.close }]),
    "aria-label": "Toggle nav"
  }, _hoisted_4, 2))
}
}

})